{
  "removeButtonLabel": "删除",
  "removeDescription": "按下“删除”以删除标记。"
}
